// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SparseItem, SparseLocation } from '@/sparse/api/types';
import { ReactNode, createContext } from 'react';

interface AdjustInventoryContextValue {
  /**
   * Whether the dialog is currently open.
   */
  isOpen: boolean;

  /**
   * The item to pre-select in the dialog (if any).
   */
  item: SparseItem | undefined;

  /**
   * The location to pre-select in the dialog (if any).
   */
  location: SparseLocation | undefined;

  /**
   * Opens the adjust inventory dialog.
   */
  openDialog: (options?: {
    item?: SparseItem;
    location?: SparseLocation;
  }) => void;

  /**
   * Closes the adjust inventory dialog.
   */
  closeDialog: () => void;
}

export const AdjustInventoryContext =
  createContext<AdjustInventoryContextValue | null>(null);

export interface AdjustInventoryProviderProps {
  children: ReactNode;
}
